import React, { Component, Children } from 'react';

interface IProps{
    isModalVisible,
    children ,
    isExpire?
}

class SFModal extends Component<IProps,{}> {
    render() {
        return (
            <div className={`sf-chatmodal ${this.props.isExpire?"sf-expire":""}`}>
                {this.props.children}
            </div>
        );
    }
}

export default SFModal;